import * as yup from "yup";

export const ACTIVITY_METADATA_NONE_VALUE = 0;

export const addActivityDataFormValidationSchema: yup.AnyObjectSchema =
    yup.object({
        activityMetadataTypeId: yup
            .number()
            .moreThan(-1, "Please select an activity metadata type"),
        rawUnitsId: yup.number().moreThan(0, "Please select raw units"),
        rawMaterialId: yup.number().moreThan(0, "Please select a raw material"),
        emissionsSourceId: yup
            .number()
            .moreThan(0, "Please enter an emissions source.")
            .required("Please enter an emissions source."),
    });

export type AddDataSourceFormValues = {
    emissionsSourceId: number;
    activityMetadataTypeId?: number;
    connectionTypeId?: number;
    rawUnitsId: number;
    rawMaterialId: number;
};

export const defaultAddDataSourceFormValues: AddDataSourceFormValues = {
    emissionsSourceId: -1,
    rawUnitsId: -1,
    rawMaterialId: -1,
    activityMetadataTypeId: ACTIVITY_METADATA_NONE_VALUE,
    connectionTypeId: 1
};
